import React from "react";

import Box from "../../../../../shared/Box";
import Headline from "../../../../../shared/Headline";
import { Link } from "../../../../../shared/LinkComponent";
import TextAlign from "../../../../../shared/TextAlign";
import headerImage from "./gewerbestrom.jpg";

const UnsupportedConsumption = () => {
    return (
        <Box>
            <Box.Image path={headerImage} format="full" height="215" />
            <Box.Content>
                <Headline>
                    Sie benötigen mehr als 100.000 kWh? Wir empfehlen Ihnen den
                    Hoyer Gewerbestrom.
                </Headline>
                <p>
                    Wenn Sie über 100.000 kWh Strom im Jahr benötigen, besuchen
                    Sie unseren Bereich für Gewerbestrom. Unsere Experten
                    beraten Sie gerne zu Ihrem individuellen Stromtarif.
                </p>
                <TextAlign align="right">
                    <Link to={"/produkte/gewerbe-strom"}>Zum Gewerbestrom</Link>
                </TextAlign>
            </Box.Content>
        </Box>
    );
};

export default UnsupportedConsumption;
